module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/451.b741580e.png";